import React from 'react';
import Menu from 'components/menu';
import SendEmail from 'pages/notifications/send-email';
import styles from './notifications.module.scss';

const Notifications = () => (
  <>
    <div className={styles.menu}>
      <Menu />
    </div>
    <div className={`${styles.inner}`}>
      <SendEmail />
    </div>
  </>
);

export default Notifications;
